import {
  WM_EXPORTER_COMPRESSION,
  WM_EXPORTER_CONTENT_TYPE,
  WM_EXPORTER_REQUIRED_KEY,
  WM_EXPORTER_TRACES_ENDPOINT,
} from './constants';

export const traces = {
  auto_instrument: true,
  load_public_functions: false,
  url: WM_EXPORTER_TRACES_ENDPOINT,
  compression: WM_EXPORTER_COMPRESSION,
  required_key: WM_EXPORTER_REQUIRED_KEY,
  headers: {
    'Content-Type': WM_EXPORTER_CONTENT_TYPE,
  },
  sampling: 1.0,
  harvester: false, // Harvester isn't enable for this signal
  resources: {},
};
